function AccountApplicationSkeleton() {
  return (
    <section style={{ gridArea: 'application' }}>
      <div className="mb-l h-[120px] animate-pulse rounded-l bg-structure-95" />
    </section>
  );
}

function AccountPlansSkeleton() {
  return (
    <section style={{ gridArea: 'plans' }}>
      <div className="flex flex-col gap-m">
        <div className="h-[40px] w-[200px] animate-pulse rounded-l bg-structure-95" />
        <div className="h-[120px] animate-pulse rounded-l bg-structure-95" />
        <div className="h-[120px] animate-pulse rounded-l bg-structure-95" />
      </div>
    </section>
  );
}

function AccountPlanViewSkeleton() {
  return (
    <section style={{ gridArea: 'plan' }}>
      <div className="flex flex-col gap-l">
        <div className="h-[100px] animate-pulse rounded-l bg-structure-95" />
        <div className="h-[200px] animate-pulse rounded-l bg-structure-95" />
      </div>
    </section>
  );
}

export function AccountContentSkeleton({ isMobile }: { isMobile: boolean }) {
  return (
    <>
      <AccountApplicationSkeleton />
      <AccountPlansSkeleton />
      {!isMobile && <AccountPlanViewSkeleton />}
    </>
  );
}
